export const defaultLocale = 'fi'

export const messages = {
    fi: {
      navbar: {
        etusivu: 'Etusivu',
        kirjaudu: 'Kirjaudu',
        kirjauduulos: 'Kirjaudu ulos',
        kirjautuneena: 'Tilisi',
        korkeakoulu: 'Kopiraittilan korkeakoulu',
        info: 'Info',
        opettajalle: 'Opettajalle',
        imateriaalioikeudet: 'Immateriaalioikeudet',
        tekijanoikeudet: 'Tekijänoikeudet',
        luovuttaminen: 'Tekijänoikeuksien luovuttaminen',
        kaytto: 'Teosten käyttö',
        oma: 'Oma tuottaminen',
        cookie: 'Käytämme sivustollamme evästeitä, jotta voisimme tarjota sinulle parhaan mahdollisen käyttökokemuksen. Jatkamalla sivuston selailua hyväksyt evästeiden käytön.' ,
        lisatietoja: 'Lisätietoa evästeistä',
        hyvaksyn: 'Hyväksyn'
      },
      general: {
        ladataan: 'Ladataan...',
        jatka: 'Jatka myöhemmin siitä mihin jäit?',
        siirry: 'Siirry',
        aloita: 'Aloita',
        seuraava: 'Seuraava',
        edellinen: 'Edellinen',
        kylla: 'Kyllä',
        ei: 'Ei',
        jatkat: 'Jatka',
        oikein: 'oikein',
        vaarin: 'väärin',
        hienoa: 'Hienoa! Läpäisit testin.',
        vastauson: 'Vastasit',
        pisteesi: 'Oikeita vastauksia yhteensä'
      },
      footer: {
        tekijat: 'Tekijät',
        kayttoehdot: 'Käyttöehdot',
        evasteet: 'Evästeet',
        evasteasetukset: 'Evästeasetukset',
        yhteystiedot: 'Yhteystiedot',
        unohditko: 'Unohditko tallennuskoodisi?',
        jaa: 'Jaa somessa!',
        copyright: 'Ⓒ Kopiosto ry. Aineiston kaupallinen ja taloudellinen hyödyntäminen tai luvaton käyttö toisen palvelun osana on kielletty ilman Kopioston lupaa.',
      },
      login: {
        ohje: 'Kirjautumalla voit tallettaa suorittamasi testit ja jatkaa myöhemmin vaikka toisella laitteella. Sähköpostiosoitettasi ei tallenneta minnekään emmekä käytä sähköpostiosoitetta muuhun tarkoitukseen, kuin kirjautumiskoodin lähettämiseen.',
        email: 'Sähköpostiosoitteesi',
        koodi: 'Kirjautumiskoodi',
        kirjaudu: 'Kirjaudu sisään',
        kirjaudutaan: 'Kirjaudutaan...',
        kirjauduulos: 'Kirjaudu ulos',
        kirjautuneena: 'Olet kirjautuneena',
        jatka: 'Jatka',
        jatkakirjautumatta: 'Jatka kirjautumatta',
        eikoodia: 'Jos sinulla ei ole koodia tai olet unohtanut sen, jätä kenttä tyhjäksi, niin lähetämme koodin sähköpostiisi.',
        laheta: 'Lähetä koodi',
        lahetetaan: 'Lähetetään...',
        lahetetty: 'Koodi lähettetty',
        jatkamyohemmin: 'Jatka myöhemmin siitä mihin jäit'
      }
    },
    sv: {
      navbar: {
        etusivu: 'Hemsida',
        kirjaudu: 'Logga in',
        kirjauduulos: 'Logga ut',
        kirjautuneena: 'Ditt konto',
        korkeakoulu: 'Kopiraittila högskola',
        info: 'Info',
        opettajalle: 'För läraren',
        imateriaalioikeudet: 'Immaterialrätt',
        tekijanoikeudet: 'Upphovsrätt',
        luovuttaminen: 'Överlåtelse av upphovsrätten',
        kaytto: 'Användning av verk',
        oma: 'Eget arbete',
        cookie: 'Vi använder kakor på webbplatsen för att kunna erbjuda dig bästa möjliga användarupplevelse. Genom att bli kvar på webbplatsen godkänner du användningen av kakor (s.k. cookies).' ,
        lisatietoja: 'Mer information om kakor',
        hyvaksyn: 'Jag godkänner'
      },
      general: {
        ladataan: 'Laddar...',
        jatka: 'Fortsätta senare?',
        siirry: 'Börja',
        aloita: 'Börja',
        seuraava: 'Nästa',
        edellinen: 'Föregående',
        kylla: 'Ja',
        ei: 'Nej',
        jatkat: 'Fortsätta',
        oikein: 'rätt',
        vaarin: 'fel',
        hienoa: 'Bra!',
        vastauson: 'Ditt svar är',
        pisteesi: 'Totalt antal rätta svar'
      },
      footer: {
        tekijat: 'Producent',
        kayttoehdot: 'Användningsvillkor',
        evasteet: 'Kakor',
        evasteasetukset: 'Cookieinställningar',
        yhteystiedot: 'Kontaktuppgifter',
        unohditko: 'Har du glömt din kod?',
        jaa: 'Dela',
        copyright: '© Kopiosto rf. Att använda materialet för kommersiella eller ekonomiska syften eller olovligen använda det som en del av en annan tjänst utan Kopiostos tillstånd är förbjudet.',
      },
      login: {
        ohje: 'Om du loggar in kan du spara de tester du har gjort och fortsätta senare, även på en annan apparat. Din e-postadress sparas ingenstans och vi använder inte din e-postadress för några andra syften än att skicka din inloggningskod.',
        email: 'E-postadress',
        koodi: 'Kod',
        kirjaudu: 'Logga in',
        kirjaudutaan: 'Loggar in...',
        kirjauduulos: 'Logga ut',
        kirjautuneena: 'Du är inloggad',
        jatka: 'Fortsätta',
        jatkakirjautumatta: 'Fortsätta utan att logga in',
        eikoodia: 'Om du inte har någon kod eller om du har glömt din kod, lämna fältet tomt så skickar vi din kod per e-post.',
        laheta: 'Skicka kod',
        lahetetaan: 'Skickar...',
        lahetetty: 'Kod skickad',
        jatkamyohemmin: 'Fortsätt senare där du var när du avslutade'
      }
    },
    en: {
      navbar: {
        etusivu: 'Homepage',
        kirjaudu: 'Login',
        kirjauduulos: 'Log out',
        kirjautuneena: 'Your account',
        korkeakoulu: 'Kopiraittila academy',
        info: 'Info',
        opettajalle: 'Teachers',
        imateriaalioikeudet: 'Intellectual property rights',
        tekijanoikeudet: 'Copyright',
        luovuttaminen: 'Transferring copyrights',
        kaytto: 'Use of works',
        oma: 'Self-producing',
        cookie: 'Our website uses cookies to allow us to provide you with the best possible user experience. By continuing to use this website you accept the use of cookies.' ,
        lisatietoja: 'More information on the cookies',
        hyvaksyn: 'I accept'
      },
      general: {
        ladataan: 'Loading...',
        jatka: 'Continue later?',
        siirry: 'Go',
        aloita: 'Start',
        seuraava: 'Next',
        edellinen: 'Previous',
        kylla: 'Yes',
        ei: 'No',
        jatkat: 'Continue',
        oikein: 'correct',
        vaarin: 'incorrect',
        hienoa: 'Well done!',
        vastauson: 'Your answer is',
        pisteesi: 'Total correct answers'
      },
      footer: {
        tekijat: 'Producers',
        kayttoehdot: 'Privacy policy',
        evasteet: 'Cookies',
        evasteasetukset: 'Cookie Settings',
        yhteystiedot: 'Contact information',
        unohditko: 'Did you lose your code?',
        jaa: 'Share',
        copyright: '© Kopiosto ry.',
      },
      login: {
        ohje: 'By logging in, you can save the tests you have passed and continue later, even on a different device. Your email address will not be saved, and we will not use it for any other purpose than to send the login code.',
        email: 'Your e-mail address',
        koodi: 'Code',
        kirjaudu: 'Log in',
        kirjaudutaan: 'Loggin in...',
        kirjauduulos: 'Log out',
        kirjautuneena: 'Currently logged in',
        jatka: 'Continue',
        jatkakirjautumatta: 'Continue without logging in',
        eikoodia: 'If you do not have a code or you have forgotten it, leave the field empty, and we will send a code to your email.',
        laheta: 'Send a code',
        lahetetaan: 'Sending...',
        lahetetty: 'Cede sent',
        jatkamyohemmin: 'Continue later where you left off',
      }
    }
}



// WEBPACK FOOTER //
// ./src/locale.js